<template>
  <div class="page">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="组织名称:">
          <el-input v-model="filter.orgName" style="width: 110px;"></el-input>
        </el-form-item>
        
        <el-form-item label="组织ID:">
          <el-input v-model="filter.orgId" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="组织编码:">
          <el-input v-model="filter.orgCode" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="门店名称:">
          <el-input v-model="filter.storeName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="门店ID:">
          <el-input v-model="filter.storeId" style="width: 110px;" maxlength="9"></el-input>
        </el-form-item>

        <el-form-item label="中台门店ID:">
          <el-input v-model.number="filter.shopId" style="width: 110px;"  maxlength="9"></el-input>
        </el-form-item>

        <el-form-item label="省份:">
          <el-select style="width:110px;" v-model="filter.provinces" filterable placeholder="全部">
            <el-option value="">省份</el-option>
            <el-option
              v-for="item in provinces"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="城市:">
          <el-select style="width:110px;" v-model="filter.citys" filterable placeholder="全部">
            <el-option value="">城市</el-option>
            <el-option
              v-for="item in citys"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="行政区域:">
          <el-select style="width:110px;" v-model="filter.districts" filterable placeholder="全部">
            <el-option value="">区域</el-option>
            <el-option
              v-for="item in districts"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
          <!-- 批量导入组织 -->
          <el-button @click="$_batchAccount" class="search__btn btn__add">批量导入组织</el-button>
        </el-form-item>
      </el-form>
    </section>
    <div class="box" v-loading="isLoading">
      <div class="left-side">
        <el-scrollbar>
          <el-tree
            ref="orgTree"
            :data="brandList"
            :props="defaultProps"
            check-on-click-node
            highlight-current
            :default-expanded-keys="expandedIds"
            :expand-on-click-node="false"
            class="brand-tree"
            node-key="id"
            @node-click="selectBrand"
          ></el-tree>
        </el-scrollbar>
      </div>
      <div class="right-side" v-if="dataObj">
        <div class="btn-box">
          <el-button size="mini" class="edit__btn" @click="$_modify">编辑</el-button>
          <el-button size="mini" class="edit__btn" @click="$_modify(-1)">新增子组织</el-button>
          <el-button size="mini" class="delete__btn" @click="$_delete" v-if="dataObj.level != 1">删除</el-button>
        </div>
        <div class="detail">
          <table class="table-dt">
            <tbody>
              <tr>
                <td>组织ID</td>
                <td>{{ dataObj.id }}</td>
              </tr>
              <tr>
                <td>组织名称</td>
                <td>{{ dataObj.level == 1 ? '运营商【' + dataObj.orgName.replace('【运营商】',"") + '】' : dataObj.orgName }}</td>
              </tr>
              <tr>
                <td>组织编码</td>
                <td>{{ dataObj.orgCode != "" ? dataObj.orgCode : '-' }}</td>
              </tr>
              <tr>
                <td>关联门店</td>
                <td><span class="chk-shop" @click="$_openStore" v-if="dataObj.storeNames.length > 0">查看门店</span>{{ dataObj.storeNames.length > 5 ? dataObj.storeNames.slice(0,5).join('，') + '...' : dataObj.storeNames.length == 0 ?  '-' : dataObj.storeNames.join('，')}}</td>
              </tr>
              <tr>
                <td>负责人</td>
                <td>{{ dataObj.leader != '' ? dataObj.leader : '-' }}</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>{{ dataObj.memo != '' ? dataObj.memo : '-' }}</td>
              </tr>
              <tr>
                <td>创建人</td>
                <td>{{ dataObj.creator }}</td>
              </tr>
              <tr>
                <td>创建时间</td>
                <td>{{ dataObj.createTime }}</td>
              </tr>
              <tr>
                <td>最后编辑人</td>
                <td>{{ dataObj.operator }}</td>
              </tr>
              <tr>
                <td>最后编辑时间</td>
                <td>{{ dataObj.updateTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 新增/编辑子组织 -->
    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      :platformKey="platformKey"
      :provinces="provinces"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <!-- 新增/编辑子组织 -->
    <stores-list
      v-if="modal.show && modal.template === 'storelist'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      :provinces="provinces"
      @close="$_close"
    ></stores-list>

    <batch-account
      v-if="modal.show && modal.template === 'batch'"
      :title="modal.title"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></batch-account>
  </div>
</template>

<script type="text/ecmascript-6">
import modalModify from "./modal-modify";
import storesList from "./modal-stores-list.vue";
import BatchAccount from "./modal-batch-account";
export default {
  name: "organization-custom",
  props: {
    platformKey: { type: String, default: "" },
    provinces: { type: Array, default: [] },
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "orgName"
      },
      list: [],
      filter: {
        orgId: "",
        orgName: '',
        orgCode: '',
        storeName: "",
        storeId: "",
        shopId: "",
        provinces: "", // 全部省份
        citys: "", // 全部城市
        districts: "", // 全部行政区域
      },
      citys: [],//城市列表
      districts: [],//地区列表
      isLoading: false,
      dataObj: null,
      modal: {
        show: false,
        type: "add",
        template: "",
        data: {}
      }
    }
  },
  computed: {
    brandList(){
      if (this.list.length > 0) {
        let arr = this.catalogsToTree(this.list);
        arr[0].orgName = '【运营商】' + arr[0].orgName;
        return arr;
      }
      return [];
    },
    expandedIds(){
      return this.list.filter(item => item.level <=2).map(item => item.id);
    }
  },
  watch: {
    'filter.provinces'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'city',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.citys = result.data.concat([]);
          }
        });
      }else{
        this.citys = [];
      }
      //重置
      this.filter.citys = '';
      this.filter.districts  = '';
    },
    'filter.citys'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'area',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.districts = result.data.concat([]);
          }
        });
      }else{
        this.districts = [];
      }
      //重置
      this.filter.districts  = '';
    },
  },
  methods:{
    // 批量导入组织
    $_batchAccount() {
      this.modal.title = "批量导入组织";
      this.modal.template = "batch";
      this.modal.show = true;
      this.modal.data = {
        dataObj: this.list
      };
    },
    catalogsToTree(catalogList) {
      let catalogs = [];
      if (catalogList.length > 0) {
        let list = catalogList.concat([]);
        let map = {};
        list.forEach(item => {
          let key = item.id;
          if (!map.hasOwnProperty(key)) {
            map[key] = item;
          }
        });
        list.forEach(item => {
          if (typeof item.parentId !== "undefined" && item.parentId !== 0) {
            map[item.parentId].children
              ? map[item.parentId].children.push(item)
              : (map[item.parentId].children = [item]);
          }
        });
        catalogs = list.filter(item => item.parentId === 0);
      }
      return [...catalogs];
    },
    // 搜索
    async $_search() {
      let reg = /[^\d.]/g;
      if(this.filter.orgId && new RegExp(reg).test(this.filter.orgId)){
         $MessageBox.alert({
          content: `
            <div>组织id需填数字！</div>
          `,
        });
      }else if(this.filter.shopId && new RegExp(reg).test(this.filter.shopId)){
        $MessageBox.alert({
          content: `<div>中台门店id需填数字！</div>`,
        });
      }else{
        await this.$_getOrganizationList();
        if(this.dataObj && this.list.find(ele=> ele.id == this.dataObj.id)){//查询结果存在组织才查询相关账号门店
          this.selectBrand(this.dataObj);
        }
      }
    },
    // 重置
    $_reset() {
      this.filter.orgId = "",
      this.filter.orgName = '',
      this.filter.orgCode = '',
      this.filter.storeName = "";
      this.filter.storeId = "";
      this.filter.provinces = "";
      this.filter.citys = "";
      this.filter.shopId = "";
      this.filter.districts = "";
      this.$_getOrganizationList();
    },
    // 查询运营商列表
    async $_getOrganizationList(flag = false) {
      this.isLoading = true;
      const postData = {
        platformKey: this.platformKey,
        orgName: this.filter.orgName,
        orgCode: this.filter.orgCode,
        storeName: this.filter.storeName,
        provinceCode: this.filter.provinces,
        cityCode: this.filter.citys,
        areaCode: this.filter.districts,
        queryType: 1,
        pageNow: 1,
        pageSize: 9999,
      };
      if(this.filter.storeId != ''){
        postData.storeId = this.filter.storeId;
      }
      if(this.filter.orgId != ''){
        postData.orgId = Number(this.filter.orgId);
      }
      if(this.filter.shopId != ''){
        postData.shopId = Number(this.filter.shopId);
      }
      this.lastFilter = JSON.parse(JSON.stringify(postData));
      await this.$service.post("getOrgList", postData).then(result => {
        this.isLoading = false;
        if (result.$.checkResult(result, true)) {
          this.list = result.data.concat([]);
          if(!flag){//不是删除都设置选中
            if(this.list.length > 0){
              let checkid = this.dataObj ? this.dataObj.id : this.list.find(ele=>ele.level==1).id;
              
              this.dataObj = this.dataObj ? this.list.find(ele=>ele.id==this.dataObj.id) : this.list.find(ele=>ele.level==1);
              this.$nextTick(function(){
                this.$refs.orgTree.setCurrentKey(checkid);
              });
            }else{
              this.dataObj = null;
            }
            
          }
          
        }
      });
    },
    // 选中品牌
    selectBrand(data){
      const postData = {
        orgId: data.id,
        pageNow: 1,
        pageSize: 6,
      };
      if(data.level == 1){//运营商
        this.dataObj = data;
        return false;
      }
      this.isLoading = true;
      this.$service.post("getOrgShopDetailList", postData).then(result => {
        this.isLoading = false;
        this.dataObj = data;
        if (result.$.checkResult(result, true)) {
          this.dataObj.storeNames = result.data.rows.map(ele => ele.storeName);
        }
      });
    },
    // 批量导入组织
    $_batchStores() {
      this.modal.title = "批量导入门店";
      this.modal.template = "batch";
      this.modal.show = true;
    },
    // 新增/编辑子组织
    $_modify($index) {
      this.modal.type = "add";
      this.modal.data = {
        list: this.list,
        dataObj: this.dataObj
      };
      this.modal.title = "新增子组织";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.title = "编辑组织";
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },
    $_delete(){
      let self = this;
      // 启用切换成停用
      $MessageBox.confirm({
        content: "确定删除该组织？",
        onOk() {
          self.isLoading = true;
          self.$service
            .post("deleteOrg", {id: self.dataObj.id})
            .then(result => {
              self.isLoading = false;
              if (result.$.checkResult(result, true)) {
                self.dataObj =null;
                self.$_getOrganizationList();
              }
            });
        },
      });
    },
    //查看关联门店
    $_openStore(){
      this.modal.title = "查看门店";
      this.modal.data = {
        dataObj: this.dataObj
      };
      this.modal.template = "storelist";
      this.modal.show = true;
    },
    // 新增/编辑组织成功回调
    async $_callback() {
      this.$_close();
      await this.$_getOrganizationList();
      this.selectBrand(this.dataObj);
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
  },
  components: {
    modalModify,
    storesList,
    BatchAccount
  },
  async created(){
    // 请求组织架构列表
    await this.$_getOrganizationList();
  },
}
</script>

<style lang="scss" scoped>
.page{
  height: 100%;
  background:rgba(249,249,249,1);
  border:1px solid #eee;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  .filter-box {
    color: #68768a;
    background-color: #f5f6f7;
    padding: 20px 20px 10px 20px;
    border-bottom:1px solid #eee;
    .top-btns {
      min-height: 50px;
    }
  }
}
.box{
  display: flex;
  flex: 1;
  height: 0;
  overflow: hidden;
  background:rgba(249,249,249,1);
  .left-side{
    width: 388px;
    height: 100%;
    border-right:1px solid #eee;
    box-sizing: border-box;
    /deep/ .brand-tree{
      display: inline-block;
      min-width: 100%;
      padding: 10px 0 0 20px;
      min-height: 200px;
      .el-tree-node__children{
        .el-tree-node__label{
          padding-right: 10px;
        }
        .is-leaf{
          display: none;
        }
      }
      .is-current>.el-tree-node__content{
        background:rgba(24,149,221,1);
        color: #fff;
        .el-tree-node__expand-icon{
          color: #fff;
        }
      }
    }
    /deep/ .el-scrollbar{
      height: 100%;
      .el-scrollbar__wrap{
        height: calc(100% + 17px);
      }
      .el-scrollbar__view{
        padding-bottom: 35px;
      }
    }
  }
  .right-side{
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 0;
    padding-left: 40px;
    .btn-box{
      padding-top: 19px;
      .el-button {
        min-width: 80px;
        height: 30px;
        padding: 0 10px;
        font-size: 13px;
        color: #fff;
        background-color: #1895dd;
        border-color: transparent;
        vertical-align: middle;
        &:focus {
          background-color: #0581c9;
        }
        &:hover {
          background-color: #36a9ec;
        }
        &.delete__btn {
          background-color: #84888c;
          &:focus {
            background-color: #6f7378;
          }
          &:hover {
            background-color: #9a9ea1;
          }
        }
      }
    }
    .detail{
      width: 100%;
      padding-top: 11px;
      .table-dt{
        width: 100%;
        color: #535353;
        td{
          height: 32px;
          &:first-child{
            width: 139px;
          }
          .chk-shop{
            color: #1895DD;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.btn__add{
  height: 25px;
  line-height: 25px;
  padding: 0px;
}
</style>
